/* Navbar dropdown menu's */

export default function initDropdown() {
	let nav = document.querySelector(".js-header-nav");
	let links = nav.getElementsByTagName("a");

	[].forEach.call(links, (element) => {
		// adds chevron down to links with submenu
		let submenu = element.nextElementSibling;
		if (submenu !== null) {
			var chevron = document.createElement("i");
			chevron.classList.add("icon-chevron");
			element.appendChild(chevron);
		}

		element.addEventListener("click", (event) => {
			let submenu = element.nextElementSibling;
			function outsideListener(e) {
				if (submenu.contains(e.target)) {
					// clicked inside dropdown
				} else {
					submenu.classList.toggle("sub-menu--active");
					window.removeEventListener("click", outsideListener);
				}
			}

			if (submenu !== null) {
				event.preventDefault();
				event.stopPropagation();
				submenu.classList.toggle("sub-menu--active");

				// listen for all clicks outside dropdown
				window.addEventListener("click", outsideListener);
			} else {
				// console.log("swupped");
			}
		});
	});
}
